import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/live-widgets/webhook'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type FundraisingEventDonationWebhookPageProps = PageProps<typeof pageUrl>
